import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/generar_poliza_inversion';
import GenerarPolizaInv from './GenerarPolizaInv';

const ms2p = (state) => {
  return {
    ...state.vm_generar_poliza_inv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(GenerarPolizaInv);
